import { render, staticRenderFns } from "./PrivacyPolicyAndTermOfUseLayout.vue?vue&type=template&id=753e0f7f"
import script from "./PrivacyPolicyAndTermOfUseLayout.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyAndTermOfUseLayout.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyAndTermOfUseLayout.vue?vue&type=style&index=0&id=753e0f7f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports